import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

// USCITA DALLA SPLASH PAGE: TESTI + CIRCLE EXPAND 
const splashExit = (data) => {

	const main = data.current.container;
	const maxDimension = Math.max(window.innerHeight, window.innerWidth) + "px";
	const logo = main.querySelector(".main-logo");
	const title = main.querySelector(".main-title");
	const text = main.querySelector(".intro");
	const buttons = main.querySelector(".double-btn");
	const mainLogo = main.querySelector(".logo svg");
	const layer = document.querySelector('.transition-overlay');
	const bgkColor = data.next.container.dataset.color;
	const header = document.querySelector('.main-navbar');

	const tl = gsap.timeline({ defaults: {ease: "power1.inOut", force3D: true} });

	tl
		.set(layer, {"--out-position": "20%", "--in-gradient": bgkColor, opacity: 0, '--width': maxDimension, '--height': maxDimension  })
		.to(layer, {opacity: 1, duration: 0.3}, 0.2)
		.to(layer, {"--out-position": "500%", duration: 2, ease: "power3.inOut"}, 0.2)
		.to([logo, title, text, buttons, mainLogo], {opacity: 0, stagger: 0.1, duration: 0.8}, 0)
		.to([logo, title, text, buttons, mainLogo], {y: -100, stagger: 0.1,duration: 1.2}, 0)
		.to(layer, {"--main-bgk": bgkColor, duration: 1, ease: "power3.inOut"}, 1)
		.set(header, {clearProps: 'height'}, ">")

	return tl;
}

// INGRESSO NELLA SPLASH PAGE: CIRCLE ROSSO + TESTI
const splashEnter = (data) => {

	const main = data.next.container;
	const maxDimension = Math.max(window.innerHeight, window.innerWidth) + "px";
	const layer = document.querySelector('.transition-overlay');
	const logo = main.querySelector(".main-logo svg");
	const introText = main.querySelector(".intro");
	const mainTitle = main.querySelector(".main-title");
	const buttons = main.querySelector(".double-btn");
	const mainLogo = main.querySelector(".logo svg");
	const header = document.querySelector('.main-navbar');

	const tl = gsap.timeline({ defaults: {force3D: true} });

	document.fonts.ready.then(() => {
		const titleSplit = SplitText.create(mainTitle, {type: "lines", autoSplit: true, mask: "lines", aria: "none"});
		const textSplit = SplitText.create(introText, {type: "lines", autoSplit: true, mask: "lines", aria: "none"});

		tl
			.set(header, {height: 0}, 0)
			.set(layer, {'--width': maxDimension, '--height': maxDimension }, 0) 
			.to(layer, {"--out-position": "500%", duration: 5, ease: "power3.inOut"}, 0)
			.to(layer, {'--main-bgk': "transparent",	duration: 1.5}, 0.8)
			.to(layer, {"--out-gradient": "transparent", duration: 3, ease: "power4.out"}, 2)

			.to(logo, { y: 0, opacity: 1, duration: 2, ease: "power2.out" }, 1.8)
			.from(titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 1.4, stagger: 0.7 }, 2)
			.from(textSplit.lines, { yPercent: 100, autoAlpha: 0, duration: 1.7, stagger: 0.2 }, 2.8)
			.to(buttons, {autoAlpha: 1, y: 0, duration: 1}, "<50%")
			.to(mainLogo, { autoAlpha: 1, duration: 1.5, ease: "power1.inOut" }, "<20%")
			.set([mainTitle, introText], {clearProps: "all"}, ">")
			.add(() => {
				titleSplit.revert();
				textSplit.revert();
			}, ">");
	});

	return tl;
}

export {splashExit, splashEnter};